/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';

/**
 * Response object for an institute address.
 * @export
 * @interface InstituteAddress
 */
export interface InstituteAddress {
    /**
     * Unique identifier of the institute address.
     * @type {string}
     * @memberof InstituteAddress
     */
    addressId?: string;
    /**
     * 
     * @type {Address}
     * @memberof InstituteAddress
     */
    address?: Address;
}

/**
 * Check if a given object implements the InstituteAddress interface.
 */
export function instanceOfInstituteAddress(value: object): value is InstituteAddress {
    return true;
}

export function InstituteAddressFromJSON(json: any): InstituteAddress {
    return InstituteAddressFromJSONTyped(json, false);
}

export function InstituteAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstituteAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'addressId': json['addressId'] == null ? undefined : json['addressId'],
        'address': json['address'] == null ? undefined : AddressFromJSON(json['address']),
    };
}

export function InstituteAddressToJSON(json: any): InstituteAddress {
    return InstituteAddressToJSONTyped(json, false);
}

export function InstituteAddressToJSONTyped(value?: InstituteAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addressId': value['addressId'],
        'address': AddressToJSON(value['address']),
    };
}

